import styled from "styled-components";

export const CreatePage = styled.div`
  width: 100%;
  min-width: 0;
  padding: 16px;
  background: #f8fafc;

  @media (max-width: 767px) {
    padding: 8px;
  }
`;

export const CreateHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: 1040px;
  margin: 0 auto 24px;

  .ant-typography {
    margin: 0;
  }
`;

export const WizardLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(190px, 236px) minmax(0, 1fr);
  gap: 24px;
  width: 100%;
  max-width: 1040px;
  margin: 0 auto;

  @media (max-width: 767px) {
    display: block;
  }
`;

export const StepsPanel = styled.aside`
  align-self: start;
  padding: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #ffffff;

  @media (max-width: 767px) {
    margin-bottom: 12px;
    padding: 12px;
  }
`;

export const ProgressLabel = styled.div`
  margin-bottom: 14px;
  color: #6b7280;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
`;

export const StepList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media (max-width: 767px) {
    flex-direction: row;
    gap: 6px;
  }
`;

export const StepButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
  padding: 10px 8px;
  border: 0;
  border-radius: 4px;
  background: ${({ $active }) => ($active ? "#eff6ff" : "transparent")};
  color: ${({ $active }) => ($active ? "#1d4ed8" : "#4b5563")};
  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};
  font: inherit;
  text-align: left;

  &:disabled {
    opacity: 1;
  }

  @media (max-width: 767px) {
    flex: 1 1 0;
    justify-content: center;
    padding: 8px 4px;
    font-size: 12px;
    text-align: center;
  }
`;

export const StepNumber = styled.span`
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 1px solid ${({ $active }) => ($active ? "#2563eb" : "#d1d5db")};
  border-radius: 50%;
  background: ${({ $active }) => ($active ? "#2563eb" : "#ffffff")};
  color: ${({ $active }) => ($active ? "#ffffff" : "#6b7280")};
  font-size: 12px;
  font-weight: 700;
`;

export const StepText = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 767px) {
    display: none;
  }
`;

export const FormPanel = styled.div`
  min-width: 0;
`;

export const FormCard = styled.div`
  padding: 24px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #ffffff;

  @media (max-width: 767px) {
    padding: 16px;
  }
`;

export const StepHeading = styled.div`
  margin-bottom: 20px;

  h2 {
    margin: 0;
    color: #111827;
    font-size: 20px;
    line-height: 28px;
  }

  p {
    margin: 4px 0 0;
    color: #6b7280;
    font-size: 13px;
  }
`;

export const FormActions = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;

  @media (max-width: 480px) {
    flex-wrap: wrap;

    > * {
      flex: 1 1 auto;
    }
  }
`;

export const ReviewGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
`;

export const ReviewItem = styled.div`
  min-width: 0;
  padding: 12px;
  border: 1px solid #eef0f2;
  border-radius: 4px;
  background: #fafafa;

  ${({ $full }) => ($full ? "grid-column: 1 / -1;" : "")}

  dt {
    margin-bottom: 4px;
    color: #6b7280;
    font-size: 12px;
  }

  dd {
    margin: 0;
    color: #111827;
    font-size: 14px;
    font-weight: 600;
    overflow-wrap: anywhere;
    white-space: pre-wrap;
  }

  @media (max-width: 600px) {
    grid-column: 1 / -1;
  }
`;
